// src/components/molecules/MoleculePopupBoard.jsx
import React, { useState } from "react";
import styled, { css } from "styled-components";

const Overlay = styled.div`
  width: 544px;
  background: white;
  box-shadow: 0px 2px 7px rgba(0,0,0,0.25);
  border-radius: 12px;
  padding: 16px;
`;

const Tabs = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
`;

const Tab = styled.button`
  flex: 1;
  padding: 8px 0;
  border-radius: 8px;
  border: 1px solid rgba(179,183,186,0.5);
  background: white;
  font-size: 19px;
  font-weight: 600;
  color: #9E9E9E;
  cursor: pointer;

  ${props =>
    props.active &&
    css`
      border-color: #256EF4;
      color: #256EF4;
    `}
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 220px;
  overflow-y: auto;
  margin-bottom: 16px;
`;

const Item = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  background: ${props => (props.hover || props.selected ? "#ECF2FE" : "white")};

  &:hover {
    background: #ECF2FE;
  }
`;

const CheckboxContainer = styled.div`
  flex: 0 0 26px;
  width: 26px;
  height: 26px;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

// 선택되지 않은 상태의 체크박스
const UncheckedSvg = () => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.921875" y="0.732422" width="24.5352" height="24.5352" rx="4" fill="transparent" stroke="rgba(179,183,186,0.5)" strokeWidth="1"/>
  </svg>
);

// 선택된 상태의 체크박스
const CheckedSvg = () => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.921875" y="0.732422" width="24.5352" height="24.5352" rx="4" fill="#256EF4"/>
    <path d="M10.7696 15.7762L18.5384 8.00742C18.7217 7.82409 18.9356 7.73242 19.18 7.73242C19.4245 7.73242 19.6384 7.82409 19.8217 8.00742C20.005 8.19076 20.0967 8.40862 20.0967 8.66101C20.0967 8.91339 20.005 9.13095 19.8217 9.31367L11.4113 17.747C11.228 17.9303 11.0141 18.022 10.7696 18.022C10.5252 18.022 10.3113 17.9303 10.128 17.747L6.1863 13.8053C6.00296 13.622 5.91496 13.4044 5.9223 13.1527C5.92963 12.9009 6.02527 12.683 6.20921 12.4991C6.39316 12.3151 6.61102 12.2235 6.8628 12.2241C7.11458 12.2247 7.33213 12.3164 7.51546 12.4991L10.7696 15.7762Z" fill="white"/>
  </svg>
);

const Title = styled.span`
  font-size: 17px;
  color: #323232;
  user-select: none;
`;

const Footer = styled.div`
  display: flex;
  justify-content: center;
`;

const ConfirmButton = styled.button`
  width: 100%;
  max-width: 480px;
  height: 40px;
  background: ${props => props.disabled ? '#E5E5EA' : '#256EF4'};
  color: white;
  font-size: 17px;
  border: none;
  border-radius: 6px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
`;

export default function MoleculePopupBoard({
  contentList = [],
  onConfirm = selected => console.log("확인된 항목:", selected),
}) {
  const [activeTab, setActiveTab] = useState("class"); // 'class' | 'meal'
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [hoverIndex, setHoverIndex] = useState(null);
  const displayItems = contentList.map(content => content.dataAnalysis?.title);

  const selectItem = idx => {
    setSelectedIndex(selectedIndex === idx ? null : idx);
  };

  const handleConfirm = () => {
    if (selectedIndex !== null) {
      // 선택된 인덱스에 해당하는 전체 content 객체를 포함하는 배열을 전달
      const selected = [contentList[selectedIndex]];
      onConfirm(selected);
    }
  };

  return (
    <Overlay>
      <Tabs>
        <Tab
          active={activeTab === "class"}
          onClick={() => setActiveTab("class")}
        >
          학급 게시판
        </Tab>
        <Tab
          active={activeTab === "meal"}
          onClick={() => setActiveTab("meal")}
        >
          급식 게시판
        </Tab>
      </Tabs>

      <List>
        {displayItems.map((title, i) => (
          <Item
            key={i}
            selected={selectedIndex === i}
            onClick={() => selectItem(i)}
            onMouseEnter={() => setHoverIndex(i)}
            onMouseLeave={() => setHoverIndex(null)}
          >
            <CheckboxContainer>
              {selectedIndex === i ? <CheckedSvg /> : <UncheckedSvg />}
            </CheckboxContainer>
            <Title>{title}</Title>
          </Item>
        ))}
      </List>

      <Footer>
        <ConfirmButton 
          disabled={selectedIndex === null}
          onClick={selectedIndex !== null ? handleConfirm : undefined}
        >
          확인
        </ConfirmButton>
      </Footer>
    </Overlay>
  );
}
